import { Box, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../../app/hooks";
import Supplements from "../../../../../common/components/functional/Supplements/Supplements";
import useIsLoading from "../../../../../hooks/useIsLoading";
import { AssignmentById } from "../../../../talents/talentAPI";
import {
  postAddAssignmentSupplement,
  postDeleteAssignmentSupplement,
  postEditAssignmentSupplement,
} from "../../../../talents/talentsSlice";

interface Props {
  assignment: AssignmentById;
  canEdit: boolean;
}

const AssignmentSupplements = ({ assignment, canEdit }: Props) => {
  const isLoading = useIsLoading(["supplements"]);

  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  //TODO: error handling
  const onAdd = (key: string, mode: string) => {
    return dispatch(
      postAddAssignmentSupplement({
        assignmentId: assignment.assignmentId,
        version: assignment.details.version,
        code: key,
        mode: mode,
      }),
    )
      .unwrap()
      .then(() => true)
      .catch(() => false);
  };

  const onEdit = (key: string, mode: string) => {
    return dispatch(
      postEditAssignmentSupplement({
        assignmentId: assignment.assignmentId,
        version: assignment.details.version,
        code: key,
        mode: mode,
      }),
    )
      .unwrap()
      .then(() => true)
      .catch(() => false);
  };

  const onDelete = (key: string) => {
    dispatch(
      postDeleteAssignmentSupplement({
        assignmentId: assignment.assignmentId,
        version: assignment.details.version,
        code: key,
      }),
    );
    return false;
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DialogTitle>
          <Typography
            variant="header"
            sx={{ fontWeight: 600, fontSize: "14px" }}
          >
            {t("talentProfile:supplementsToShow").toUpperCase()}
          </Typography>
        </DialogTitle>
      </Box>
      {assignment?.details?.tesId && (
        <Box
          sx={{
            maxWidth: "50%",
            marginLeft: "15%",
          }}
        >
          <Supplements
            areTesVariationsValid={true} // TODO: Check if this is valid
            tesId={assignment.details.tesId}
            tesSelections={assignment?.details?.tesSelections || []}
            date={assignment?.details?.start}
            supplements={assignment?.supplements || []}
            isLoading={isLoading}
            onAdd={onAdd}
            onEdit={onEdit}
            onDelete={onDelete}
            modalTitle={t(
              "talentProfile:showToCustomerSupplement",
            ).toUpperCase()}
            modalSupplementSelectLabel={t("order:supplementSelectLabel")}
            modalSupplementOptionalityLabel={t(
              "order:supplementOptionalityLabel",
            )}
            canEdit={canEdit}
          />
        </Box>
      )}
    </>
  );
};

export default AssignmentSupplements;
